import { Skeleton } from "@/components/ui/skeleton";

const FeatureItemSkeleton = () => {
  return (
    <div className="flex aspect-square w-[80px] flex-col items-center justify-start gap-2 rounded-md bg-gradient-to-r from-gray-50 to-gray-100 p-1.5 pt-2 shadow-sm sm:w-[110px] sm:gap-3 sm:p-2.5 sm:pt-5">
      <Skeleton className="aspect-square w-10" />
      <Skeleton className="h-4 w-full" />
    </div>
  );
};

const FeaturesSkeleton = () => {
  return (
    // <div className="my-10 grid grid-cols-3 items-center justify-start gap-x-4 gap-y-6 rounded sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-9">
    <div className="my-10 flex flex-wrap gap-6">
      {Array.from({ length: 12 }).map((_, i) => (
        <FeatureItemSkeleton key={i} />
      ))}
    </div>
  );
};

export default FeaturesSkeleton;
